export enum PaddingCount {
    One = 1,
    Two = 2,
    Three = 3,
    Four = 4
}
